// @ts-nocheck
import { removeCookie } from "@insite/client-framework/Common/Cookies";
import constants from "@store/constants";
import { useIsAuthenticated } from "@store/Framework/Store/Context/ContextHooks";
import { useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import { useEffect } from "react";

export const useHandlePagesCookies = () => {
    useHandleChangeCustomerPageCookies();
};

export const useHandleChangeCustomerPageCookies = () => {
    const isAuthenticated = useIsAuthenticated();
    const changeCustomerPageUrl = usePageLinkByPageType(constants.pageType.changeCustomer)?.url;
    const currentLocation = useLocation();
    const signinPageUrl = usePageLinkByPageType(constants.pageType.signIn)?.url;

    useEffect(() => {
        if (changeCustomerPageUrl !== undefined && signinPageUrl !== undefined) {
            if (
                isAuthenticated &&
                currentLocation.pathname !== changeCustomerPageUrl &&
                currentLocation.pathname !== signinPageUrl
            ) {
                removeCookie(constants.cookies.showChangeCustomerPageVariant);
            }
        }
    }, [isAuthenticated, changeCustomerPageUrl, currentLocation]);
};
